// components/DayShiftModal.jsx
import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Toggle from './toggle';
import ComboboxAutocomplete from './combobox_autocomplete';
import { DailyShift } from './daily_shift';
import { BriefcaseIcon } from '@heroicons/react/24/solid';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import TabellaTurnoGiornaliero from './tabella_visualizza_turno giornaliero';

export default function DayCreateSelectShiftModal({
    modalOpen,
    setModalOpen,
    selectedDay,
    selectedOption,
    handleToggleChange,
    setSelectedWorkingHourId,
    setSelectedWorkingHourToDisplay,
    setShiftsByDay,
    setShiftToSave,
    handleAddDailyShift,
    selectedAddDailyShift = false, 
    setSelectedAddDailyShift,
    workingHours,
    handleSelectWorkingHour,
    selectedWorkingHour,
    shiftToSave,
    handleShiftAdded,
    handleShiftDeleted,
    shiftsByDay,
    creatingWWH,
    handleCloseModal,
    allowHiddenBreaks,
}) {
    return (
        <Transition.Root show={modalOpen} as={Fragment}>
            <Dialog className="relative" style={{ zIndex: '999'}} onClose={() => {}}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-top justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-gray-50 items-center flex justify-center mx-8 shadow-xl transition-all my-8 w-3/4 2xl:w-2/4 pt-4">
                                <div className="px-4 w-full">
                                    {selectedDay && (
                                        <>
                                            <div className='flex justify-between px-4 mt-2 mb-4'>
                                                <h5 className="text-sm font-medium text-gray-700  items-center">
                                                    Seleziona un turno giornaliero da assegnare al giorno selezionato oppure crea un nuovo turno
                                                </h5>
                                                 <button
                                                    type="button"
                                                    className="border shadow-md bg-white text-gray-700 text-sm w-24 px-2 py-1 rounded-md hover:bg-gray-200 focus:outline-none font-semibold"
                                                    onClick={() => handleCloseModal(selectedDay)}
                                                >
                                                    CHIUDI
                                                </button>
                                            </div>
                                            

                                            <div className="px-4 pb-4">
                                                <Toggle
                                                    color="indigo"
                                                    gradeBgColor="600"
                                                    optionLeft="ASSEGNA TURNO GIORNALIERO"
                                                    optionRight="CREA TURNO"
                                                    selectedOption={selectedOption}
                                                    onChange={(newOption) => {
                                                        handleToggleChange(newOption);
                                                        if (newOption === 'CREA TURNO') {
                                                            setSelectedWorkingHourId(null);
                                                            setSelectedWorkingHourToDisplay(null);
                                                            setShiftsByDay((prev) => ({ ...prev, [selectedDay]: [] }));
                                                            setShiftToSave((prev) => ({ ...prev, [selectedDay]: [] }));
                                                            setSelectedAddDailyShift(true); 
                                                            handleAddDailyShift();
                                                        } else {
                                                            setSelectedAddDailyShift(false);
                                                            setShiftToSave((prev) => ({ ...prev, [selectedDay]: [] }));
                                                        }
                                                    }}
                                                />
                                            </div>

                                            {selectedOption === 'ASSEGNA TURNO GIORNALIERO' && (
                                                <div className="px-4 pb-6">
                                                    <div className="grid grid-cols-1 px-8 w-full bg-white py-4 border border-gray-200 shadow-md rounded-md relative z-[999]">
                                                        {workingHours.length > 0 ? (
                                                            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full my-3">
                                                                <div className="w-full sm:w-auto">
                                                                    <span className="text-sm font-medium text-gray-700">Seleziona il turno giornaliero</span>
                                                                </div>
                                                                <div className="w-full border border-gray-200 rounded-lg shadow-md">
                                                                    <ComboboxAutocomplete
                                                                        options={workingHours}
                                                                        bgActiveColor="bg-indigo-50"
                                                                        textActiveColor="text-gray-900"
                                                                        placeholder="Seleziona Turno Giornaliero"
                                                                        onChange={handleSelectWorkingHour}
                                                                        value={selectedWorkingHour}
                                                                        positionOptions="relative"
                                                                        zIndex="999"
                                                                    />
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="col-span-6 flex justify-center py-5 items-center w-full rounded-lg border-2 border-dashed border-gray-300 text-sm font-semibold text-gray-900">
                                                                <div className="text-center p-5">
                                                                    <p>Nessun turno giornaliero presente</p>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {selectedWorkingHour && (
                                                            <TabellaTurnoGiornaliero selectedWorkingHour={selectedWorkingHour} />
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            {selectedOption === 'CREA TURNO' && (
                                                <>
                                                    {selectedDay && (Array.isArray(shiftToSave[selectedDay]) || selectedAddDailyShift) && (
                                                        <div className="mx-4 mb-4">
                                                            <DailyShift
                                                                key={selectedDay}
                                                                selectedDay={selectedDay}
                                                                onShiftAdded={handleShiftAdded}
                                                                onShiftDeleted={handleShiftDeleted}
                                                                shiftData={shiftsByDay[selectedDay]}
                                                                creatingWWH={creatingWWH}
                                                                allowHiddenBreaks={allowHiddenBreaks}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            
                                            {(selectedWorkingHour || (shiftToSave[selectedDay]?.length > 0)) && (
                                                <div className="mt-2 pt-2 justify-center mb-4">
                                                    <button
                                                        type="button"
                                                        className="bg-indigo-600 text-white text-sm px-4 py-2 rounded-md hover:bg-indigo-500 w-28 font-semibold me-4
                                                                    focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-white"
                                                        onClick={() => setModalOpen(false)}
                                                    >
                                                        SALVA
                                                    </button>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
